import React from "react";
import { Box, Paper, Typography, Skeleton } from "@mui/material";

function StatCard({ label, value, loading, tone }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: "1px solid rgba(226,232,240,0.9)",
        background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)",
      }}
    >
      <Typography sx={{ fontSize: 12, color: "#64748B", fontWeight: 700 }}>
        {label}
      </Typography>
      {loading ? (
        <Skeleton width={56} height={38} sx={{ mt: 0.75 }} />
      ) : (
        <Typography
          sx={{
            mt: 0.5,
            fontSize: 30,
            lineHeight: 1.1,
            fontWeight: 800,
            color: tone,
          }}
        >
          {value}
        </Typography>
      )}
    </Paper>
  );
}

export default function FirmwareStats({ stats = {}, loading = false }) {
  return (
    <Box
      sx={{
        mt: 2,
        display: "grid",
        gap: 1.5,
        gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
      }}
    >
      <StatCard
        label="Total Updates"
        value={stats.total_updates || 0}
        loading={loading}
        tone="#1E3A8A"
      />
      <StatCard
        label="Successful"
        value={stats.successful || 0}
        loading={loading}
        tone="#166534"
      />
      <StatCard
        label="Failed"
        value={stats.failed || 0}
        loading={loading}
        tone="#B91C1C"
      />
    </Box>
  );
}
